import { createContext, useContext } from 'react';

interface NavigationProgressContextValue {
  start: (delay?: number) => void;
}

export const NavigationProgressContext =
  createContext<NavigationProgressContextValue>({
    start: () => {},
  });

export const useNavigationProgress = () =>
  useContext(NavigationProgressContext);
